import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b9a0701"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-4 fs-7" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-content-center mb-5"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = { class: "mb-5" }
const _hoisted_8 = { class: "d-flex justify-content-center mb-5" }
const _hoisted_9 = { class: "fw-bold py-2 px-3 history" }
const _hoisted_10 = { class: "col-lg-3 fw-bold align-items-center fs-7 abc" }
const _hoisted_11 = { class: "col-lg-3" }
const _hoisted_12 = { class: "version col-lg-1 d-flex justify-content-center align-items-center" }
const _hoisted_13 = ["onClick"]

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import View from './View.vue'
import Confirm from './Confirm.vue'
import { useRoute } from 'vue-router'
import { DEFAULT_MIN_LENGTH } from '@/constants/number'
import { ref, computed, watchEffect, onMounted } from 'vue' //validate
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import useVuelidate from '@vuelidate/core'
import { required, minLength } from '@vuelidate/validators'
import { ALUMNI_REGISTER_FORM_STORE } from '@/store/constants'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import { useStore } from 'vuex'
import { Modal } from 'bootstrap'
import { ReplayName } from '@/constants/common.ts'
import { ConvertFromLocalTime } from '@/constants/datepicker.ts'
import { cloneDeep } from 'lodash'
import { REGEX_EMOJI } from '@/constants/regex'
import { customMaxLength } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const store = useStore()
const idView = ref('')
const loading = ref<boolean>(false)
const disable = ref<boolean>(true)
// const dataCheck = ref('')
const modalView = ref()
const rules = computed(() => {
  return {
    content: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 20000),
      emoji: function (value) {
        return REGEX_EMOJI.test(value)
      },
    },
  }
})
const data = ref({})
const dataTerm = computed(() => store.getters[ALUMNI_REGISTER_FORM_STORE.GETTERS.TERMS_OF_SERVICES])
const dataCheck = computed(() => store.getters[ALUMNI_REGISTER_FORM_STORE.GETTERS.DATA_CHECK])
onMounted(() => {
  modalView.value = new Modal(document.getElementById('viewModal'))
})

onMounted(async () => {
  loading.value = true
  await store.dispatch(ALUMNI_REGISTER_FORM_STORE.ACTIONS.SET_TERMS_OF_SERVICES, { id: route?.params?.id, params: { user_type: route?.query?.tab || 'alumni' } })
  data.value = cloneDeep(dataTerm.value[0]) || {}
  if (route?.query?.version_id) {
    modalView.value?.show()
    idView.value = Number(route?.query?.version_id)
  }
  loading.value = false

  // dataCheck.value = dataTerm.value[0]?.content
})
watchEffect(
  // () => data,
  () => {
    if (data.value?.content !== dataCheck.value && data.value?.content) {
      disable.value = false
    } else {
      disable.value = true
    }
  }
  // {
  //   immediate: true,
  // }
)

const v$ = useVuelidate(rules, data)

const changeIdView = (id: string) => {
  idView.value = id
}

const onSubmit = (): void => {
  v$.value.$touch()

  if (v$.value.$invalid) return
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(route)?.query?.tab === 'alumni' || !_unref(route)?.query?.tab ? _unref(translate)('CD40textAlumnus') : _unref(translate)('CD40textEmployee')), 1),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (!loading.value)
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                onSubmit: _withModifiers(onSubmit, ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("textarea", {
                    name: "text",
                    class: _normalizeClass(['form-control fs-7 p-5', _unref(v$).content.$error ? 'is-invalid' : '']),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).content.$model) = $event)),
                    placeholder: "",
                    rows: "15"
                  }, null, 2), [
                    [_vModelText, _unref(v$).content.$model]
                  ]),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)('termOfService'),
                    params: [1, 20000],
                    validator: _unref(v$).content.$errors[0]?.$validator
                  }, null, 8, ["title", "validator"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(Button, {
                    title: _unref(translate)('confirm'),
                    type: 'secondary',
                    className: 'fw-bold',
                    dataBsToggle: 'modal',
                    dataBsTarget: _unref(v$).$invalid ? '' : '#confirmModal',
                    disabled: disable.value
                  }, null, 8, ["title", "dataBsTarget", "disabled"])
                ])
              ], 40, _hoisted_6))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(translate)('CD40changeHistory')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataTerm), (history, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: history?.id
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(['p-3 d-flex  row mx-0 justify-content-start align-items-center', index % 2 !== 0 ? 'item-bg' : ''])
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", {
                      class: _normalizeClass(history?.created_employee_user?.admin_community_management_id === null ? 'display' : 'd-flex')
                    }, [
                      _createVNode(UserAliasIcon, {
                        userType: history?.created_employee_user?.user_type || 3
                      }, null, 8, ["userType"]),
                      _createElementVNode("span", null, _toDisplayString(_unref(ReplayName)(
                  history?.created_employee_user?.is_deleted_in_30_days,
                  history?.created_employee_user?.available,
                  history?.created_employee_user?.family_name,
                  history?.created_employee_user?.given_name,
                  1
                )), 1)
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(translate)('CDUpdateDate') + ' : ') + " " + _toDisplayString(_unref(ConvertFromLocalTime)(history?.created_at)), 1),
                  _createElementVNode("div", _hoisted_12, "Ver. " + _toDisplayString(history?.version), 1),
                  (index !== 0)
                    ? (_openBlock(), _createElementBlock("u", {
                        key: 0,
                        class: "cursor-pointer col-lg-4",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#viewModal",
                        onClick: ($event: any) => (changeIdView(history.version))
                      }, _toDisplayString(_unref(translate)('CD40view')), 9, _hoisted_13))
                    : _createCommentVNode("", true)
                ], 2)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(View, {
      historyData: _unref(dataTerm)?.find((e) => e.version === idView.value)
    }, null, 8, ["historyData"]),
    _createVNode(Confirm, {
      terms: data.value?.content,
      version: _unref(dataTerm)[0]?.version,
      targetUser: _unref(dataTerm)[0]?.created_employee_community_information_family_name,
      targetUserOther: _unref(dataTerm)[0]?.created_employee_community_information_given_name
    }, null, 8, ["terms", "version", "targetUser", "targetUserOther"])
  ], 64))
}
}

})